module.exports = __webpack_public_path__ + "img/news.9f4d5de5.webp";